module.exports = __webpack_public_path__ + "img/serve6.f2388dfd.png";